import React, {memo} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {useInitialEffect} from '../../../../../libs/shared/helpers/src/react/hooks/useEffectHelpers';
import {useAppSelector} from '../../../../helpers/reduxHelpers';
import {
  closeWindow,
  hideWindowsTitleBar,
  maximizeWindow,
  minimizeWindow,
  unmaximizeWindow,
} from '../../../../services/electron/electronBridgeOutbound';
import {getCanHideWindowsTitleBar, getIsMaximized} from '../../../../store/electron/electronSelectors';
import {WindowsTitleBarButton, WindowsTitleBarButtonVariantsEnum} from './windowsTitleBarButton';

/*
 * Props.
 */

interface WindowsTitleBarControlsProps {
  className?: string;
}

/*
 * Styles.
 */

const WrapperDiv = styled.div`
  // Disable drag.
  -webkit-app-region: no-drag;

  display: flex;
`;

/*
 * Component.
 */

export const WindowsTitleBarControls = memo<WindowsTitleBarControlsProps>(({className}) => {
  const canHideWindowsTitleBar = useAppSelector(getCanHideWindowsTitleBar);
  const isMaximized = useAppSelector(getIsMaximized);

  useInitialEffect(() => {
    if (!canHideWindowsTitleBar) {
      return;
    }

    hideWindowsTitleBar();
  });

  if (!canHideWindowsTitleBar) {
    return null;
  }

  return (
    <WrapperDiv className={className}>
      <WindowsTitleBarButton
        label={<Trans id="windowstitlebarcontrols-minimize">Minimize</Trans>}
        iconName="windowsMinimize"
        onClick={minimizeWindow}
      />

      {isMaximized ? (
        <WindowsTitleBarButton
          label={<Trans id="windowstitlebarcontrols-unmaximize">Restore down</Trans>}
          iconName="windowsUnmaximize"
          onClick={unmaximizeWindow}
        />
      ) : (
        <WindowsTitleBarButton
          label={<Trans id="windowstitlebarcontrols-maximize">Maximize</Trans>}
          iconName="windowsMaximize"
          onClick={maximizeWindow}
        />
      )}

      <WindowsTitleBarButton
        variant={WindowsTitleBarButtonVariantsEnum.DANGER}
        label={<Trans id="windowstitlebarcontrols-close">Close</Trans>}
        iconName="windowsClose"
        onClick={closeWindow}
      />
    </WrapperDiv>
  );
});
